"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSPARENT_COLOR = exports.TERTIARY_INLINE_FOCUS_WIDTH = exports.TERTIARY_HORIZONTAL_PADDING = exports.SMALL_BUTTON_WIDTH = exports.REGULAR_BUTTON_WIDTH = exports.REGULAR_BUTTON_HEIGHT = exports.OUTLINE_WIDTH = exports.OUTLINE_OFFSET = exports.BUTTON_ICON_GAP = exports.BORDER_WIDTH = exports.BORDER_RADIUS_INLINE = exports.BORDER_RADIUS = exports.ARIA_DISABLED_TEXT_COLOR = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _utils2 = require("../utils");
const BORDER_WIDTH = exports.BORDER_WIDTH = 2;
const OUTLINE_WIDTH = exports.OUTLINE_WIDTH = 2;
const OUTLINE_OFFSET = exports.OUTLINE_OFFSET = BORDER_WIDTH - 1;
const REGULAR_BUTTON_HEIGHT = exports.REGULAR_BUTTON_HEIGHT = Math.max(40, _utils2.A11Y_MIN_SIZE);
const SMALL_BUTTON_WIDTH = exports.SMALL_BUTTON_WIDTH = 96;
const REGULAR_BUTTON_WIDTH = exports.REGULAR_BUTTON_WIDTH = 128;
const TERTIARY_HORIZONTAL_PADDING = exports.TERTIARY_HORIZONTAL_PADDING = 16;
const TERTIARY_INLINE_FOCUS_WIDTH = exports.TERTIARY_INLINE_FOCUS_WIDTH = 3;
const BORDER_RADIUS = exports.BORDER_RADIUS = 'R700';
const BORDER_RADIUS_INLINE = exports.BORDER_RADIUS_INLINE = 'R100';
const BUTTON_ICON_GAP = exports.BUTTON_ICON_GAP = 'S200';
const TRANSPARENT_COLOR = exports.TRANSPARENT_COLOR = (0, _utils.token)('color.transparent.alpha0');
//for aria-disabled the interactive contrast ratio is applicable since the button can be focused by tab
const ARIA_DISABLED_TEXT_COLOR = exports.ARIA_DISABLED_TEXT_COLOR = (0, _utils.token)('color.link.neutral-default');